import { Box } from '@mui/material'
import './index.scss'

export default function BrandLoading({ type = 'full', noText = false, className = '' }) {
  const theme = (process.env.REACT_APP_THEME_NAME || 'TTDK').toUpperCase()

  return (
    <Box
      className={`TrafficViolationsBrandLoading ${className}`.trim()}
      sx={{
        height: type === 'full' ? '100vh' : '60px'
      }}>
      <img src="/logoFull.png" alt={`${theme} loading`} className="TrafficViolationsBrandLoading_icon" />

      {/* {!noText && (
        <Typography variant="body2" sx={{ color: '#000', fontWeight: 500 }}>
          Đang tải dữ liệu...
        </Typography>
      )} */}
    </Box>
  )
}
